import { grey } from '@mui/material/colors';

export const getSchoolsHead = (cityName, countryName) => {
  let dinamycFromTitle = '';

  if (countryName) dinamycFromTitle = `em ${countryName}`;
  if (cityName) dinamycFromTitle = `em ${cityName} ${countryName}`;

  const title = `Intercâmbio ${dinamycFromTitle} com a Fluencypass`;
  const metaDescription = `Compare escolas ${dinamycFromTitle} sem taxa de agência, com suporte e assessoria grátis.`;

  return { title, metaDescription };
};

export const extractPathSegments = (asPath) => {
  let pathSegments = '';
  const paths = asPath.match(/\w.+(?=\?)/g);

  if (paths) pathSegments = paths[0].split('/');

  return pathSegments;
};

export const showBorder = (tabIndex, tabsMax) => {
  let border = {};

  // conditional to show border only on even numbers
  if (tabIndex % 2 === 0) {
    // conditional to not show border on the left of last tab
    if (tabIndex + 1 !== tabsMax)
      border = {
        borderRight: `2px solid ${grey[300]}`,
      };
    else
      border = {
        borderLeft: `2px solid ${grey[300]}`,
      };
  }

  return border;
};
